<template>
  <div>
    <div v-if="currentView == 'B'">
      <h1 class="text-center primary--text">Add/Delete {{typeName}} Names</h1>
      <h3 class="text-center primary--text">Tournament: {{ tourName }}</h3>
      <v-text-field :label="labelName" 
        v-model="teamName" append-icon="mdi-plus-thick"
        @click:append="addTeam"
        @keyup.enter="addTeam"
      />
      <v-row>
        <v-btn outlined color="primary" @click="goPrev">
          <v-icon>mdi-skip-previous</v-icon>
          Prev
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="goNext">
          Next
          <v-icon>mdi-skip-next</v-icon>
        </v-btn>
      </v-row>
      <v-card class="mt-5">
        <v-list color="white" dense>
          <v-subheader>
            GROUP MEMBERS
            <v-spacer></v-spacer>
            {{ groupMembers.length }}
          </v-subheader>
          <v-list-item-group>
            <v-list-item v-for="(name, index) in groupMembers" :key="name" color="primary">
              <v-list-item-content>
                <v-list-item-title class="primary--text" v-text="name"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="red" @click="delMember(index)">mdi-close</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </div>
    <div v-if="currentView=='C' && groupId != 0">
      <GroupGames :tourId="tourId" :groupId="groupId" @message="currentView='B'"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import GroupGames from '@/components/GroupGames.vue'

export default {
  name: 'tourGroup',
  components: { GroupGames },
  props: [ 'tourId', 'gameType', 'tourName' ],
  computed: {
    ...mapGetters([
      'tourGroups', 'tourGroupsLoaded'
    ]),
  },
  watch: {
    tourGroupsLoaded: function() {
      if (this.tourGroups.length > 0) {
        this.groupName = this.tourGroups[0].groupName
        this.groupMembers = this.tourGroups[0].groupMembers
        this.groupId = this.tourGroups[0].tourGroupId
      } else {
        this.groupId = 0
        this.groupMembers.splice(0)
      }
    }
  },
  data: () => ({
    typeName: '', 
    labelName: '',
    teamName: '',
    groupMembers: [],
    groupName: 'Group-1',
    groupId: 0,
    groupNo: 1,
    currentView: 'B',
    entryChanged: false,
  }),
  created() {
    this.typeName = (this.gameType == 'I') ? 'Individual' : 'Team'
    this.labelName = (this.gameType == 'I') ? 'Enter Individual Name' : 'Enter Team Name'
    //if (this.tourId != 0) {
      this.$store.dispatch('getTourGroups', this.tourId)
    //} else {
    //  this.tourId  = ''
    //  this.groupMembers.splice(0)
    //}
  },
  methods: {
    saveGroup() {
      if (this.entryChanged) {
        var group = {
          tournamentId: this.tourId,
          groupNum: this.groupNo,
          groupName: this.groupName,
          groupMembers: this.groupMembers
        }
        const token = this.$store.getters.authToken
        if (token) {
          const header = { 'Content-Type': 'application/json', 'x-auth': token }
          axios.post('/api/tourGroup', JSON.stringify(group), { headers: header })
          .then(response => {
            this.groupId = response.data
            this.entryChanged = false
          })
          .catch(err => {
            alert(err.response.data.err)
          })
        }
      }
    },
    addTeam() {
      var name = this.teamName.trim()
      if (name !== '') {
        var ind = this.groupMembers.indexOf(name)
        if (ind < 0) {
          this.groupMembers.push(name)
          this.entryChanged = true
        }
      }
      this.teamName = ''
    },
    delMember(index) {
      this.groupMembers.splice(index, 1)
      this.entryChanged = true
    },
    goPrev() {
      this.saveGroup()
      this.$emit('message', '')
    },
    goNext() {
      this.saveGroup()
      this.currentView = 'C'
    }
  }
}
</script>